import DefaultTable from '@components/UI/DefaultTable';
import ContainerTypeTableHeaderData from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/TruckTypeInformation/mocks';
import TruckTypeInformationStyledContainer from '@pages/AdditionalServices/tabs/DeliveryForm/components/RoutesCalculationWidget/TruckTypeInformation/StyledComponents';
import { LocalizedMessage } from '@services/requests/localizedMessagesService/interfaces';
import { TrucksData } from '@services/requests/searchLoaders/trucksLoader/TrucksLoaderQuery';
import { UnitData } from '@services/requests/searchLoaders/unitLoader/UnitLoaderQuery';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface TruckTypeInformationProps {
  trucks: TrucksData[];
  units: UnitData[];
  lang: string;
}
const TruckTypeInformation: FC<TruckTypeInformationProps> = ({ trucks, lang, units }) => {
  const { t } = useTranslation('RoutesCalculationWidget');

  /**
   * Получение локализованного названия
   * @param defaultName
   * @param localizations
   */
  const handleGenerateLocalizedName = (
    defaultName: string,
    localizations: LocalizedMessage[]
  ): string => {
    const localization = localizations.find((l) => l.lang_id === lang);
    if (!localization || localization.message.length === 0) {
      return defaultName;
    }

    return localization.message;
  };

  const rows = trucks.map((truck) => ({
    id: truck.id,
    default_name: handleGenerateLocalizedName(truck.default_name, truck.localized_names_data),
    height: truck.height,
    length: truck.length,
    width: truck.width,
    ldm: truck.ldm,
    max_volume: truck.max_volume,
    max_weight: truck.max_weight,
    count_pallets: truck.countPallets
      .map((pallet) => ({
        pallet: units.find((u) => u.id === pallet.type_pallet),
        count: pallet.count_pallet,
      }))
      .filter((pallet) => Boolean(pallet.pallet))
      .map(
        (u) =>
          `${handleGenerateLocalizedName(
            u.pallet.unit_symbol,
            u.pallet.localized_unit_symbols_data
          )} - ${u.count}`
      )
      .join(', '),
  }));
  return (
    <TruckTypeInformationStyledContainer>
      <div className={'title'}>{t('RoutesCalculationWidget:SpecificationsTrucks')}</div>
      <DefaultTable rows={rows} columns={ContainerTypeTableHeaderData()} />
    </TruckTypeInformationStyledContainer>
  );
};

export default TruckTypeInformation;
